import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import React, { useState } from "react";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";

function RandomStringGenerator(darkMode) {
  const [useDigits, setUseDigits] = useState(true);
  const [useLower, setUseLower] = useState(true);
  const [useUpper, setUseUpper] = useState(true);
  const [useSymbols, setUseSymbols] = useState(false);
  const [length, setLength] = useState(12);
  const [count, setCount] = useState(5);
  const [results, setResults] = useState([]);
  const [copied, setCopied] = useState(false);

  const charset = () => {
    let chars = "";
    if (useDigits) chars += "0123456789";
    if (useLower) chars += "abcdefghijklmnopqrstuvwxyz";
    if (useUpper) chars += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (useSymbols) chars += "!@#$%^&*()-_=+[]{};:,.<>/?";
    return chars;
  };

  const generateStrings = () => {
    const chars = charset();
    if (!chars) return;

    const generated = Array.from({ length: count }, () =>
      Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join("")
    );
    setResults(generated);
    setCopied(false);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(results.join("\n"));
    setCopied(true);
  };

  return (
    <DashboardLayout>
      <MDBox py={3}>
        <MDBox mt={4.5}>
          <Grid container spacing={3} pt={3} pl={4} pr={3}>
            <Grid item xs={12}>
              <MDTypography variant="h2" color={darkMode ? "dark" : "white"}>
                Random string generator
              </MDTypography>
              <MDTypography variant="body1" mt={2} mb={4} color={darkMode ? "dark" : "white"}>
              Customize your strings by selecting the character types and specifying how many strings to generate and their length.
              </MDTypography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <MDInput
                    label="String length"
                    type="number"
                    fullWidth
                    value={length}
                    onChange={(e) => setLength(parseInt(e.target.value))}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <MDInput
                    label="Number of strings"
                    type="number"
                    fullWidth
                    value={count}
                    onChange={(e) => setCount(parseInt(e.target.value))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox checked={useDigits} onChange={(e) => setUseDigits(e.target.checked)} />}
                    label="Use digits (0–9)"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={useLower} onChange={(e) => setUseLower(e.target.checked)} />}
                    label="Use lowercase letters (a–z)"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={useUpper} onChange={(e) => setUseUpper(e.target.checked)} />}
                    label="Use uppercase letters (A–Z)"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={useSymbols} onChange={(e) => setUseSymbols(e.target.checked)} />}
                    label="Use symbols (!@#$...)"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button size="small" variant="contained" color="secondary" onClick={generateStrings}>
                    <MDTypography color={"black"} fontSize="1rem">
                      Generate
                    </MDTypography>
                  </Button>
                </Grid>
              </Grid>

              {results.length > 0 && (
                <MDBox mt={4}>
                  <MDTypography variant="h5" mb={1} display="flex" alignItems="center" gap={1}>
                    Results
                    <IconButton onClick={copyToClipboard} title="Copy to clipboard">
                      <ContentCopyIcon color={darkMode ? "dark" : "white"}/>
                        <span style={{ fontSize: "0.9rem",paddingLeft:10, color: darkMode ? "#665" : "#665" }}>
                        {copied ? "Copied" : "Copy"}
                      </span>
                    </IconButton>
                  </MDTypography>
                  <pre style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    borderRadius: "8px",
                    overflowX: "auto",
                    border: "1px solid #233584"
                  }}>
                    {results.join("\n")}
                  </pre>
                </MDBox>
              )}
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RandomStringGenerator;
